import React from 'react'
import { Skeleton, TableCell, TableRow } from '@mui/material'

const SkeletonRow = React.memo(({ height }) => (
  <TableRow>
    <TableCell colSpan='100%' height={height}>
      <Skeleton width='100%' height='100%' />
    </TableCell>
  </TableRow>
))

export default SkeletonRow
